import React from 'react';
import { ID, withCodes } from 'app/blocks/common/codes';
import FundingInformation from '../ConfirmPriceChange/FundingInformation/FundingInformation';
import './confirmCountryChange.scss';

type Props = {
    readonly countryName: string;
    readonly initialCountryName: string;
    readonly percentageDiscount?: number;
    readonly l: l;
};

function ConfirmCountryChange({
    countryName,
    initialCountryName,
    percentageDiscount,
    l,
}: Props) {
    const seleniumid = 'article-affiliations-editor-confirm-country-change';

    // Determine if it's a geographical waiver (100%) or discount (<100%)
    const isGeographicalWaiver = percentageDiscount === 100;
    
    // Select the appropriate title, description and label based on type
    const titleKey = isGeographicalWaiver
        ? 'ARTICLE_AFFILIATION_EDITOR.CONFIRM_COUNTRY_CHANGE_TITLE_GEOGRAPHICAL_WAIVER'
        : 'ARTICLE_AFFILIATION_EDITOR.CONFIRM_COUNTRY_CHANGE_TITLE_GEOGRAPHICAL_DISCOUNT';
    
    const descriptionKey = isGeographicalWaiver 
        ? 'ARTICLE_AFFILIATION_EDITOR.CONFIRM_COUNTRY_CHANGE_DESCRIPTION_GEOGRAPHICAL_WAIVER'
        : 'ARTICLE_AFFILIATION_EDITOR.CONFIRM_COUNTRY_CHANGE_DESCRIPTION_GEOGRAPHICAL_DISCOUNT';
    
    const apcLabelKey = isGeographicalWaiver
        ? 'ARTICLE_AFFILIATION_EDITOR.CONFIRM_COUNTRY_CHANGE_APC_WAIVER_LABEL'
        : 'ARTICLE_AFFILIATION_EDITOR.CONFIRM_COUNTRY_CHANGE_APC_DISCOUNT_LABEL';

    return (
        <div className="confirmCountryChange" data-seleniumid={seleniumid}>
            <div className="confirmCountryChange__header">
                <h2 className="confirmCountryChange__title" data-seleniumid={`${seleniumid}-title`}>
                    {l(titleKey)}
                </h2>
                <p 
                    className="confirmCountryChange__description" 
                    data-seleniumid={`${seleniumid}-description`}
                    dangerouslySetInnerHTML={{ __html: l(descriptionKey, { country: initialCountryName }) }}
                />
            </div>

            <div className="confirmCountryChange__content">
                <FundingInformation
                    icon="locationOnCountry"
                    label={l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_COUNTRY_CHANGE_COUNTRY_LOCATION_LABEL')}
                    seleniumid={`${seleniumid}-country`}
                    value={countryName}
                />
                <FundingInformation
                    icon="money"
                    label={l(apcLabelKey)}
                    seleniumid={`${seleniumid}-waiver`}
                    value={l('ARTICLE_AFFILIATION_EDITOR.CONFIRM_COUNTRY_CHANGE_NOT_ELIGIBLE')}
                />
            </div>
        </div>
    );
}

ConfirmCountryChange.defaultProps = {
    percentageDiscount: undefined,
};

export default withCodes(ConfirmCountryChange, ID.ARTICLE_AFFILIATION_EDITOR);
